import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { clearChunkRecoveryFlag, installChunkRecoveryListeners } from "./lib/chunkRecovery";

installChunkRecoveryListeners();
// Clear the stale-chunk reload guard only after the app has stayed stable.
// Clearing it immediately can create an endless reload loop while lazy chunks are still failing.
if (typeof window !== "undefined") {
  window.setTimeout(clearChunkRecoveryFlag, 30000);
}


const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element not found");
}

createRoot(rootEl).render(<App />);

if (typeof window !== "undefined") {
  const loadFonts = () => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Noto+Sans+Bengali:wght@400;700&display=optional";
    link.media = "print";
    link.onload = () => {
      link.media = "all";
    };
    document.head.appendChild(link);
    import("./lib/performance").then((module) => module.loadDeferredFonts()).catch(() => {});
  };

  window.addEventListener(
    "load",
    () => {
      if ("requestIdleCallback" in window) {
        (window as Window & { requestIdleCallback: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number }).requestIdleCallback(loadFonts, { timeout: 3000 });
        return;
      }
      globalThis.setTimeout(loadFonts, 2500);
    },
    { once: true },
  );
}
